import { render, staticRenderFns } from "./RegistrationResultsLearners.vue?vue&type=template&id=2ab7269b&scoped=true"
import script from "./RegistrationResultsLearners.vue?vue&type=script&lang=js"
export * from "./RegistrationResultsLearners.vue?vue&type=script&lang=js"
import style0 from "./RegistrationResultsLearners.vue?vue&type=style&index=0&id=2ab7269b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7269b",
  null
  
)

export default component.exports